



















import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class LicenseTypePara extends CommonBase {
    @Prop()
    licenseType!: number;
}
